import { GetStaticProps } from 'next';
import { NewsPageId } from '../../../features/app/pages/domain/constants/PageId';
import { getStaticPathsForLocales } from '../../../features/app/pages/domain/use-cases/getStaticPathsForLocales';
import NewsPage from '../../../features/news/ui/NewsPage';
import {
	getLatestNewsStories,
	getMostRecentHighlightedNewsStories,
} from '../../../features/news/domain/use-cases/news-story';
import {
	getAllBlogItems,
	getLatestBlogItems,
} from '../../../features/news/domain/use-cases/blog-item';
import { getMostRecentPressReleases } from '../../../features/news/domain/use-cases/press-releases';
import { getSocialMediaData } from '../../../features/news/domain/use-cases/social-media';
import { getEnrichedPageById } from '../../../features/app/pages/domain/use-cases/getEnrichedPageById';
import { getLocaleFromPath } from '../../../features/shared/i18n/locale/getLocaleFromPath';
import { defaultLocale } from '../../../features/shared/i18n/locale/constants/default';
import { INewsPageData } from '../../../features/news/domain/models/INewsPageData';

export const getStaticPaths = getStaticPathsForLocales;

export const getStaticProps: GetStaticProps<INewsPageData> = async ({
	params,
}) => {
	const locale = getLocaleFromPath(params?.locale ?? '') ?? defaultLocale;

	const [
		page,
		highlighedNewsStory,
		recentNewsStories,
		blogItems,
		pressReleases,
		recentBlogItems,
		socialMediaData,
	] = await Promise.all([
		getEnrichedPageById(NewsPageId.Home, locale),
		getMostRecentHighlightedNewsStories(locale),
		getLatestNewsStories(3, locale),
		getAllBlogItems(locale),
		getMostRecentPressReleases(locale),
		getLatestBlogItems(2, locale),
		getSocialMediaData(),
	]);

	if (!page) {
		return {
			notFound: true,
		};
	}

	return {
		props: {
			page,
			highlighedNewsStory,
			recentNewsStories,
			blogItems,
			pressReleases,
			recentBlogItems,
			socialMediaData,
		},
	};
};

export default NewsPage;
